export enum NODE_TYPES {
  OPTION = "option",
  QUESTION = "question",
  STATEMENT = "statement",
}
